import { render } from "./ContractTemplateModal.vue?vue&type=template&id=70d1206c&scoped=true"
import script from "./ContractTemplateModal.vue?vue&type=script&lang=js"
export * from "./ContractTemplateModal.vue?vue&type=script&lang=js"

import "./ContractTemplateModal.vue?vue&type=style&index=0&id=70d1206c&scoped=true&lang=css"
import "./ContractTemplateModal.vue?vue&type=style&index=1&id=70d1206c&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70d1206c"]])

export default __exports__